import { Either, Option } from 'funfix-core';
import { List, Record } from 'immutable';
import { ANALYTICS_DONE_PAGE_VIEW, ANALYTICS_LOADED_ERROR, ANALYTICS_LOADED_SUCCESS, ANALYTICS_MODAL_CLOSED, ANALYTICS_MODAL_OPENED, ANALYTICS_SCREEN_CHANGED, ANALYTICS_SEND_PAGE_VIEW } from '../../actions/Analytics';
import { ANALYTICS_SCREEN_DISCOVER } from '../../analytics/Sources';
export const makeAnalyticsReduxState = Record({
  analyticsLoadResult: Option.none(),
  currentScreen: ANALYTICS_SCREEN_DISCOVER,
  modalStack: List(),
  lastScreenEvent: undefined,
  attributes: {
    mountPath: ''
  }
});
export default function AnalyticsReducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : makeAnalyticsReduxState();
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ANALYTICS_LOADED_SUCCESS:
      return state.set('analyticsLoadResult', Option.some(Either.right()));
    case ANALYTICS_LOADED_ERROR:
      return state.set('analyticsLoadResult', Option.some(Either.left(action.dataErrorMessages)));
    case ANALYTICS_MODAL_OPENED:
      {
        const modal = action.modal;
        return state.update('modalStack', ss => ss.filterNot(s => s === modal).push(modal));
      }
    case ANALYTICS_MODAL_CLOSED:
      {
        const modal = action.modal;
        return state.update('modalStack', ss => ss.filterNot(s => s === modal));
      }
    case ANALYTICS_SCREEN_CHANGED:
      return state.set('currentScreen', action.screen).set('attributes', action.attributes);
    case ANALYTICS_SEND_PAGE_VIEW:
      return state;
    // This redux action is all side-effect. See analytics/middleware/ScreenView.js
    case ANALYTICS_DONE_PAGE_VIEW:
      return state.set('lastScreenEvent', action.source);
    default:
      // Flow compile-time validation that we've handled every action
      // prettier-ignore
      action;
      return state;
  }
}